document.addEventListener("DOMContentLoaded", function() {
    let customDelay = +document.querySelector('#desktop-delay').dataset["customDelay"];
  
    new Swiper('.js-bar-mobile-container', {
      spaceBetween: 0,
      autoplay: true,
      delay: customDelay,
      slidesPerView: "auto",
      breakpoints: {
        320: {
          initialSlide: 0,
          slidesPerView: 1
        },
        650: {
          initialSlide: 0,
          slidesPerView: 1
        },
        800: {
          initialSlide: 0,
          slidesPerView: 1
        },
        900: {
          initialSlide: 0,
          slidesPerView: "auto"
        }
      }
    });
  });
  
  document.addEventListener("DOMContentLoaded", function() {
    new Swiper('.js-bar-no-mobile-container', {
      spaceBetween: 0,
      breakpoints: {
        320: {
          initialSlide: 0,
          slidesPerView: 1
        },
        650: {
          initialSlide: 0,
          slidesPerView: 1
        },
        800: {
          initialSlide: 0,
          slidesPerView: 1
        },
        900: {
          initialSlide: 0,
          slidesPerView: "auto"
        }
      }
    });
  });
  
  